const doc = [({"zh_tw":({"adminConstantHotelChildrenSettingCategorySimpleChildrenSetting":({"children":"兒童", "infants":"幼兒"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;